import { useQuery } from "@tanstack/react-query"
import { useTRPCClient } from "utils/trpc"

const useShouldShowEcosystemTab = ({ chainId }: { chainId: string }) => {
  const trpcClient = useTRPCClient()
  const { data: dataIdsOnChains = [], isLoading } = useQuery({
    queryKey: ["chains-data-id-availability", chainId],
    queryFn: async () => {
      const result = await trpcClient.chains.getProjectsByChain.query({
        chain_ids: [chainId],
      })

      return result.data
    },
    enabled: !!chainId,
    staleTime: 1000 * 60 * 60 * 24, // 1 day
  })

  const dataIdsOnChainItem = dataIdsOnChains.find(
    (chain) => chain.chain_id === chainId
  )

  if (!dataIdsOnChainItem) {
    return {
      data: false,
      isLoading,
    }
  }

  // Filter out the chainId itself
  return {
    data: dataIdsOnChainItem.data_ids.filter((id) => id !== chainId).length > 0,
    isLoading,
  }
}

export default useShouldShowEcosystemTab
